var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddressLogoOptimized(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 26.904c4.228 0 7.667-3.439 7.667-7.667S27.228 11.57 23 11.57s-7.667 3.439-7.667 7.667 3.439 7.667 7.667 7.667Zm0-11.5a3.837 3.837 0 0 1 3.833 3.833A3.837 3.837 0 0 1 23 23.07a3.837 3.837 0 0 1-3.833-3.833A3.837 3.837 0 0 1 23 15.404Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.889 41.88a1.912 1.912 0 0 0 2.223 0c.583-.411 14.277-10.3 14.222-22.643 0-8.454-6.88-15.333-15.334-15.333S7.667 10.783 7.667 19.228C7.61 31.58 21.306 41.468 21.889 41.88ZM23 7.738c6.342 0 11.5 5.158 11.5 11.51.04 8.506-8.41 16.144-11.5 18.649-3.088-2.507-11.54-10.147-11.5-18.659 0-6.342 5.158-11.5 11.5-11.5Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressLogoOptimized);
export default __webpack_public_path__ + "static/media/addressLogo-optimized.585671afe2dad3985c228f13af380057.svg";
export { ForwardRef as ReactComponent };